import * as backend from '@/api/backend';
import { checkResponseStatus } from '@/util/check';

const defaultState = {
  admins: [],
  loading: false,
  error: false,
};

const mutations = {
  fetchAdmins(state) {
    state.loading = true;
  },
  errorAdmins(state) {
    state.admins = [];
    state.loading = false;
    state.error = true;
  },
  setAdmins(state, admins) {
    state.admins = admins;
    state.loading = false;
    state.error = false;
  },
};

const actions = {
  async fetchAdmins({ commit }) {
    commit('fetchAdmins');
    const response = await backend.getAdmins();
    try {
      await checkResponseStatus(200, response);
      const json = response.data;
      commit('setAdmins', json);
    } catch {
      commit('errorAdmins');
    }
  },

  async deleteAdmin({ dispatch }, adminID) {
    const response = await backend.deleteAdmin(adminID);
    await checkResponseStatus(204, response);
    dispatch('fetchAdmins');
  },

  async postAdmin({ dispatch }, email) {
    const response = await backend.postAdmin({ email });
    await checkResponseStatus(201, response);
    dispatch('fetchAdmins');
  },
};

export default {
  namespaced: true,
  state: defaultState,
  mutations,
  actions,
};
